/** @see $bog_builderui_tokens */
namespace $ {
	$mol_style_define( $bog_builderui_studio_pick, {
		flex: {
			direction: 'row',
			grow: 0,
		},
		justify: {
			content: 'flex-start',
		},
		align: {
			self: 'stretch',
			items: 'stretch',
		},
		padding: {
			top: '0.75rem',
			bottom: '0.75rem',
			left: '1rem',
			right: '1rem',
		},
		background: {
			color: '#171717',
		},
		border: {
			radius: '0.625rem',
			width: '1px',
			style: 'solid',
			color: '#262626',
		},
		color: '#fafafa',
		cursor: 'pointer',
		Texts: {
			flex: {
				direction: 'column',
				grow: 1,
			},
			align: {
				items: 'flex-start',
			},
			gap: '0.125rem',
		},
		Label: {
			font: {
				size: '0.75rem',
				weight: 400,
			},
			color: '#737373',
		},
		Value: {
			font: {
				size: '0.95rem',
				weight: 600,
			},
			color: '#fafafa',
		},
		Dot: {
			align: {
				self: 'center',
			},
			width: '14px',
			height: '14px',
			minWidth: '14px',
			border: {
				radius: '50%',
				width: 0,
			},
		},
	} )
}
